var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultCurrency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.453125,
    y: 0.5625,
    width: 40.8755,
    height: 40.8755,
    rx: 18.0288,
    fill: "#ED1C00",
    fillOpacity: 0.15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.453125,
    y: 0.5625,
    width: 40.8755,
    height: 40.8755,
    rx: 18.0288,
    fill: "white",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0586 13.917H16.7253C14.2253 13.917 12.5586 15.167 12.5586 18.0837V23.917C12.5586 26.8337 14.2253 28.0837 16.7253 28.0837H25.0586C27.5586 28.0837 29.2253 26.8337 29.2253 23.917V18.0837C29.2253 15.167 27.5586 13.917 25.0586 13.917ZM16.1003 23.0837C16.1003 23.4253 15.8169 23.7087 15.4753 23.7087C15.1336 23.7087 14.8503 23.4253 14.8503 23.0837V18.917C14.8503 18.5753 15.1336 18.292 15.4753 18.292C15.8169 18.292 16.1003 18.5753 16.1003 18.917V23.0837ZM20.8919 23.5003C19.5086 23.5003 18.3919 22.3837 18.3919 21.0003C18.3919 19.617 19.5086 18.5003 20.8919 18.5003C22.2753 18.5003 23.3919 19.617 23.3919 21.0003C23.3919 22.3837 22.2753 23.5003 20.8919 23.5003ZM26.9336 23.0837C26.9336 23.4253 26.6503 23.7087 26.3086 23.7087C25.9669 23.7087 25.6836 23.4253 25.6836 23.0837V18.917C25.6836 18.5753 25.9669 18.292 26.3086 18.292C26.6503 18.292 26.9336 18.5753 26.9336 18.917V23.0837Z",
    fill: "#ED1C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0586 13.917H16.7253C14.2253 13.917 12.5586 15.167 12.5586 18.0837V23.917C12.5586 26.8337 14.2253 28.0837 16.7253 28.0837H25.0586C27.5586 28.0837 29.2253 26.8337 29.2253 23.917V18.0837C29.2253 15.167 27.5586 13.917 25.0586 13.917ZM16.1003 23.0837C16.1003 23.4253 15.8169 23.7087 15.4753 23.7087C15.1336 23.7087 14.8503 23.4253 14.8503 23.0837V18.917C14.8503 18.5753 15.1336 18.292 15.4753 18.292C15.8169 18.292 16.1003 18.5753 16.1003 18.917V23.0837ZM20.8919 23.5003C19.5086 23.5003 18.3919 22.3837 18.3919 21.0003C18.3919 19.617 19.5086 18.5003 20.8919 18.5003C22.2753 18.5003 23.3919 19.617 23.3919 21.0003C23.3919 22.3837 22.2753 23.5003 20.8919 23.5003ZM26.9336 23.0837C26.9336 23.4253 26.6503 23.7087 26.3086 23.7087C25.9669 23.7087 25.6836 23.4253 25.6836 23.0837V18.917C25.6836 18.5753 25.9669 18.292 26.3086 18.292C26.6503 18.292 26.9336 18.5753 26.9336 18.917V23.0837Z",
    fill: "white",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCurrency);
export default __webpack_public_path__ + "static/media/default-currency.43b35bc309a161bec281065ad97fba3c.svg";
export { ForwardRef as ReactComponent };